import { LOGOUT, SET_STRUCTURE, SET_UNITS_LIST, SET_EDIT_UNIT_NAME, SET_EDIT_UNIT_SETTINGS, SET_EDIT_EMPLOYEES_LIST, SET_EDIT_SUB_UNITS_LIST, SET_EDIT_SUPERVISORS_LIST } from "../actions/types";

const INITIAL_STATE = {
    unit: {
        ouID: null,
        symbol: null,
        name: null,
        sort: null,
        parentAcceptMode: null,
        currentAcceptMode: null,
        parentOuID: null,
        parentOuName: null
    },
    subUnits: [],
    supervisors: [],
    employees: [],
    list: [],
    edit: {
        name: null,
        parentAcceptMode: null,
        currentAcceptMode: null,
        employees: [],
        subUnits: [],
        supervisors: []
    }
};

const mapUnits = units => {
    return units.map(unit => {
        return {
            ouID: unit.ouID,
            name: unit.name,
            symbol: unit.symbol,
            sort: unit.sort,
            parentAcceptMode: unit.parentAcceptMode,
            currentAcceptMode: unit.currentAcceptMode,
            subOUs: mapUnits(unit.subOUs)
        }
    })
};

const structureReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_STRUCTURE:
            return {
                ...state,
                unit: {
                    ouID: action.payload.unit.ouID,
                    symbol: action.payload.unit.symbol,
                    name: action.payload.unit.name,
                    sort: action.payload.unit.sort,
                    parentAcceptMode: action.payload.unit.parentAcceptMode,
                    currentAcceptMode: action.payload.unit.currentAcceptMode,
                    parentOuID: action.payload.unit.parentOuID,
                    parentOuName: action.payload.unit.parentOuName
                },
                subUnits: action.payload.subUnits.map(subUnit => {
                    return {
                        ouID: subUnit.ouID,
                        symbol: subUnit.symbol,
                        name: subUnit.name,
                        sort: subUnit.name,
                        parentAcceptMode: subUnit.parentAcceptMode,
                        currentAcceptMode: subUnit.currentAcceptMode,
                        parentOuID: subUnit.parentOuID,
                    };
                }),
                supervisors: action.payload.supervisors.map(supervisor => {
                    return {
                        supervisorID: supervisor.supervisorID,
                        userID: supervisor.userID,
                        email: supervisor.email,
                        fname: supervisor.fname,
                        lname: supervisor.lname,
                        priority: supervisor.priority,
                        dateFrom: supervisor.dateFrom,
                        dateTo: supervisor.dateTo
                    };
                }),
                employees: action.payload.employees.map(employee => {
                    return {
                        userID: employee.userID,
                        email: employee.email,
                        fname: employee.fname,
                        lname: employee.lname
                    };
                })
            };
        case SET_UNITS_LIST:
            return {
                ...state,
                list: mapUnits(action.payload)
            };
        case SET_EDIT_UNIT_NAME:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    name: action.payload
                }
            };
        case SET_EDIT_UNIT_SETTINGS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    parentAcceptMode: action.payload.parentAcceptMode,
                    currentAcceptMode: action.payload.currentAcceptMode
                }
            };
        case SET_EDIT_EMPLOYEES_LIST:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    employees: action.payload.map(employee => {
                        return {
                            userID: employee.userID,
                            email: employee.email,
                            fname: employee.fname,
                            lname: employee.lname
                        };
                    })
                }
            };
        case SET_EDIT_SUB_UNITS_LIST:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    subUnits: action.payload.map(subUnit => {
                        return {
                            ouID: subUnit.ouID,
                            symbol: subUnit.symbol,
                            name: subUnit.name,
                            sort: subUnit.sort,
                            parentAcceptMode: subUnit.parentAcceptMode,
                            currentAcceptMode: subUnit.currentAcceptMode,
                            parentOuID: subUnit.parentOuID,
                        };
                    })
                }
            };
        case SET_EDIT_SUPERVISORS_LIST:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    supervisors: action.payload.map(supervisor => {
                        return {
                            supervisorID: supervisor.supervisorID,
                            userID: supervisor.userID,
                            email: supervisor.email,
                            fname: supervisor.fname,
                            lname: supervisor.lname,
                            priority: supervisor.priority,
                            dateFrom: supervisor.dateFrom !== null ? supervisor.dateFrom : "",
                            dateTo: supervisor.dateTo !== null ? supervisor.dateTo : ""
                        };
                    })
                }
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default structureReducer;